<template>
    <v-container class="ma-0 pa-0 stop1_container" fill-height >
        <v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12"  align-self="start" class="step1_title_descript mt-7 mb-8">
				사용자 기본 정보를 작성해주세요.
			</v-col>
            <v-col cols="12" align-self="start">
                <p class="step01_items_title mb-0" style="font-size:12px; letter-Spacing:0.6px; color:#193263;">성별</p>
                <v-col cols="12" align-self="center" align="left" class="ma-0 px-0 py-5">
                    <input
                        v-model="gender_m"
                        type="checkbox"
                        id="gender_m"
                        class="terms_check"
						@click="onClickGender(1)"
                    />
					<label
                        for="gender_m"
                        tabindex="1"
                        role="checkbox"
                        @click="onClickGender(1)"
                    >
                        남성
                    </label>

                    <input
                        v-model="gender_f"
                        type="checkbox"
                        id="gender_f"
                        class="terms_check"
						@click="onClickGender(2)"
                    />
					<label
                        class="ml-5"
                        for="gender_f"
                        tabindex="2"
                        role="checkbox"
                        @click="onClickGender(2)"
                    >
                        여성
                    </label>

                    <p class="err_msg mt-1" style="float:right;" v-if="errorMsg0 !== ''">
                        {{errorMsg0}}
                    </p>
                </v-col>
            </v-col>
            <v-row class="ma-0 pa-0 mt-5">
                <v-col cols="6" align-self="center" align="left" class="ma-0 pa-0 pr-1">
                    <label class="step01_items_title">
                        이름
                        <input
                            class="default_input mt-1"
                            ref="name"
                            role="textbox"
                            v-model="userInfo.name"
                            placeholder="홍길동"
                        />
                    </label>
                    <div class="err_ly">
                        <p v-if="errorMsg1 !== ''" class="err_msg">
                            {{errorMsg1}}
                        </p>
                    </div>
                </v-col>
                <v-col cols="6" align-self="center" class="ma-0 pa-0 pl-1">
                    <label class="step01_items_title">
                        생년월일
                        <!-- <input

                            type="date"
                            class="default_input mt-1"
                            ref="birth"
                            v-model="userInfo.birthday"
                        /> -->
                    </label>
                    <div class="mt-1 pa-0 pt-1 pl-2 pr-1 default_input d-flex justify-space-between">
                        <div class="input-item">
                            <label class="d-flex justify-space-between" style="color: rgba(0,0,0,0.3);">
                                <input
                                    type="number"
                                    id="yyyy"
                                    v-model="yyyy"
                                    maxlength="4"
                                    min="1920"
                                    max="2030"
                                    role="textbox"
                                    class="input_yy"
                                    placeholder="YYYY"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                />
                                .
                            </label>
                        </div>
                        <div class="input-item">
                            <label class="d-flex justify-space-between" style="color: rgba(0,0,0,0.3);">
                                <input
                                    type="number"
                                    id="mm"
                                    v-model="mm"
                                    maxlength="2"
                                    min="1"
                                    max="12"
                                    role="textbox"
                                    class="input_mm"
                                    placeholder="MM"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                />
                                .
                            </label>
                        </div>
                        <div class="input-item">
                            <label class="d-flex justify-space-between" style="color: rgba(0,0,0,0.3);">
                                <input
                                    type="number"
                                    id="dd"
                                    v-model="dd"
                                    maxlength="2"
                                    min="1"
                                    max="31"
                                    role="textbox"
                                    class="input_dd"
                                    placeholder="DD"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                />
                                .
                            </label>
                        </div>
                    </div>
                    <div class="err_ly">
                        <p class="err_msg" v-if="errorMsg2 !== ''">
                            {{errorMsg2}}
                        </p>
                    </div>
                </v-col>
            </v-row>

            <v-row class="ma-0 pa-0 mt-5">
                <v-col cols="6" align-self="center" align="left" class="ma-0 pa-0 pr-1">
                    <label class="step01_items_title">
                        키 (cm)
                        <input
                            class="default_input mt-1"
                            ref="height"
                            type="number"
                            v-model="userInfo.height"
                            placeholder="cm"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            min="1"
                            max="999"
                        />
                    </label>
                    <div class="err_ly">
                        <p class="err_msg" v-if="errorMsg3 !== ''">
                            {{errorMsg3}}
                        </p>
                    </div>
                </v-col>
                <v-col cols="6" align-self="center" class="ma-0 pa-0 pl-1">
                    <label class="step01_items_title">
                        몸무게 (Kg)
                        <input
                            class="default_input mt-1"
                            ref="weight"
                            type="number"
                            v-model="userInfo.weight"
                            placeholder="kg"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            min="1"
                            max="999"
                        />
                    </label>
                    <div class="err_ly">
                        <p class="err_msg" v-if="errorMsg4 !== ''">
                            {{errorMsg4}}
                        </p>
                    </div>
                </v-col>
            </v-row>
        </v-row>
                
        <v-row v-if="isShinhanCustomer" dense class="ma-0 pa-0 px-7 mt-5 mb-15">
            <v-col cols="12" class="ma-0 pa-0 pr-1">
                <p style="color: #7559d7; font-size: 12px;">신한라이프 이벤트 참여를 위해 아래 정보를 입력해 주세요.</p>
                <label class="step01_items_title">
                    휴대폰 번호
                    <input
                        class="default_input mt-1"
                        ref="height"
                        type="number"
                        v-model="userInfo.mobile"
                        placeholder="'-' 제외하고 숫자만 입력"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        min="1"
                        max="999"
                    />
                </label>
            
                <div class="err_ly">
                    <p class="err_msg" v-if="errorMsg5 !== ''">
                        {{errorMsg5}}
                    </p>
                </div>
            </v-col>
            <v-col cols="12" align-self="center">			
				<div class="ck_u">
					<input
                        v-model="userInfo.isTermsAgree"
                        type="checkbox"
                        id="terms1"
                        class="terms_check"
                    />
					<label
                        for="terms1"
                        tabindex="8"
                        role="checkbox"
                        @keydown.enter="userInfo.isTermsAgree = !userInfo.isTermsAgree"
                    >
                        제 3자 정보 이용 동의 (필수)
                    </label>
					<span
                        class="privacy_link"
                        role="link"
                        tabindex="9"
                        @click="showPopup(1)"
                    >
                        보기
                    </span>
				</div>

			</v-col>
        </v-row>

        <!-- popup -->
        <VThirdPartyTermsPopup v-if="popupView1" @closePop="closePopup" />
        <!-- // popup -->

        <v-container class="ma-0 pa-0 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" align-self="end" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="10"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9"  align-self="end" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="disabledBtn ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						:disabled="!disabledBtn"
						tabindex="11"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
        <v-toast ref="toast" />
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import VToast from "@/components/popup/toast.vue"
import VThirdPartyTermsPopup from "@/components/popup/thirdPartyTermsPopup.vue"
import utils from "@/utils/utils"
import moment from 'moment'
import api from '@/utils/apiCaller'

export default {
    components: {
        VToast,
        VThirdPartyTermsPopup
    },
	mixins: [utils, ],
	data () {
	    return {
            userInfo: {
                name: null,
                birthday: null,
                height: null,
                weight: null,
                gender: null,
                mobile: null,
                isTermsAgree: false
            },
            yyyy:null,
            mm:null,
            dd:null,
            enableButton: false,
            errorMsg0: '',
            errorMsg1: '',
            errorMsg2: '',
            errorMsg3: '',
            errorMsg4: '',
            errorMsg5: '',
            errorType: 'none',
            options: [1,2,3,4,5,6,7,8,9],
            currentValue: null,
            gender_m : null,
            gender_f : null,
            changed : 0,

            prevScrollY: 0,
            popupView1: false

        }
    },
	computed: {
		...mapGetters("user", {
			getUser: "getUser"
		}),
        ...mapGetters("survey", {
			checkUp: "checkUp"
        }),
        disabledBtn() {
            const birthdayCheck = this.yyyy && this.mm && this.dd
            const userInfoCheck = this.userInfo.gender && this.userInfo.name && this.userInfo.height && this.userInfo.weight
            const errorMsgs = [
                this.errorMsg0,
                this.errorMsg1,
                this.errorMsg2,
                this.errorMsg3,
                this.errorMsg4,
                this.errorMsg5
            ];
            const shinhanCheck = this.userInfo.mobile && this.userInfo.isTermsAgree
            const errerMsgCheck = errorMsgs.every(errorMsg => errorMsg === '')
            if (this.isShinhanCustomer) {
                if (userInfoCheck && birthdayCheck && errerMsgCheck && shinhanCheck) {
                    return true
                } else {
                    return false
                }
            } else {
                if (userInfoCheck && birthdayCheck && errerMsgCheck) {
                    return true
                } else {
                    return false
                }
            }
        },
        isShinhanCustomer () {
            if( this.getUser && (this.getUser.siteId === 1 || this.getUser.siteId === 2) ) {
                return true
            }
            return false
        }
	},
	methods: {
		...mapActions("user", ["setUser"]),
		...mapActions("survey", ["setCheckupTemp", "setStep"]),
		//이전
		previous() {
			this.setStep(1)
			this.$router.push("/userTerms");
		},
		//다음
		async next () {
            if(this.isShinhanCustomer) {
                if(this.userInfo.mobile) {
                    if(this.userInfo.mobile.length < 10 || this.userInfo.mobile.length > 11) {
                        this.$refs.toast.open('전화번호 형식을 확인해 주세요.')
                        return false
                    }
                    else if(!this.userInfo.isTermsAgree) {
                        this.$refs.toast.open('약관을 동의해주세요.')
                        return false
                    }
                }
                else {
                    this.$refs.toast.open('전화번호를 입력해 주세요.')
                    return false
                }

                const param = {
                    authToken: this.getUser.authToken,
                    name: this.userInfo.name, 
                    mobile: this.userInfo.mobile
                }
                const res = await api.sign.updateInfo(param) // 이름, 전화번호 정보를 서버에 저장
                if(Number(res.data.code) !== 200) {
                    this.$refs.toast.open('사용자 정보를 저장하는 중 오류가 발생했습니다. (' + res.data.code + ')')
                    return false
                }
            }

            const {yyyy, mm, dd} = this
            const birthday = moment(`${yyyy}-${mm}-${dd}`, "YYYY-MM-DD").format('YYYYMMDD')
            if (!moment(`${yyyy}-${mm}-${dd}`, "YYYY-MM-DD").isValid()) {
                this.errorMsg2 = "생년월일을 다시 확인해주세요."
                this.errorType = 'birth'
                this.birthday = null
                return false
            }
            this.userInfo.birthday = birthday
            const age = this.calcAge(birthday);
			if (age < 20 || age >= 90) {
				this.errorMsg2 = "만 20세 미만, 90세 이상은 서비스의 대상이 아닙니다."
                this.errorType = 'birth'
				return false;
			}
			const params = {
				step: 1,
				name: this.userInfo.name,
				birthday: this.userInfo.birthday,
                gender: this.userInfo.gender.toString(),
                bmi: this.calcBMI(this.userInfo.weight, this.userInfo.height)
			};
            await this.setUser(params); // 이름, 생년월일 저장

            const paramsHW = {
                step: 3,
				height: this.userInfo.height,
				weight: this.userInfo.weight,
				bmi: this.calcBMI(this.userInfo.weight, this.userInfo.height)
            }
            await this.setCheckupTemp(paramsHW);
			this.setStep(4)
			this.$router.push("/checkup/step4");
		},
		//버튼활성화
		buttonChange () {
            this.trimDate()
            // console.log(this.userInfo.gender, this.gender_m, this.gender_f)
            // if(this.userInfo.gender === null) {
            //     this.enableButton = false
            // }
            this.enableButton = false
            
            if(this.userInfo.name !== null && this.userInfo.name.length > 0) {
                const age = this.calculateAge()
                if(age >= 20 && age <= 90) {
                    if(this.mm > 0 && this.mm < 13) {
                        if(this.dd > 0 && this.dd < 32) {
                            if (!moment(`${this.yyyy}-${this.mm}-${this.dd}`, "YYYY-MM-DD").isValid()) {
                                this.errorMsg2 = "생년월일을 다시 확인해주세요."
                                this.errorType = 'birth'
                            } else {
                                this.enableButton = true
                                this.errorMsg2 = ''
                            }
                        }
                        else if(this.dd !== null) {
                            this.errorMsg2 = '일은 1에서 31까지만 입력가능합니다.'
                            this.errorType = 'birth'
                        }
                    }
                    else if(this.mm !== null) {
                        this.errorMsg2 = '월은 1에서 12까지만 입력가능합니다.'
                        this.errorType = 'birth'
                    }
                }
                else {
                    if(this.yyyy && this.mm && this.dd) {
                        this.errorMsg2 = "20세에서 90세까지 가능"
                        this.errorType = 'birth'
                    }
                }

                if( this.userInfo.gender  && 
                    (this.userInfo.height && this.userInfo.height.length > 0) && 
                    (this.userInfo.weight && this.userInfo.weight.length > 0) &&
                    this.userInfo.mobile ) 
                {
                    this.errorMsg = ""
                    this.enableButton = true
                } else {
                    this.enableButton = false
                }
            }
        },
        calculateAge() {
            return new Date().getFullYear() + 1 - this.yyyy
        },
		restoreData() {
			if (this.getUser.name !== null) {
				this.userInfo.name = this.getUser.name;
			}
			if (this.getUser.birthday !== null) {
				const birth = moment(this.getUser.birthday)
				this.userInfo.birthday = Number(birth.format('YYYYMMDD'))
				this.yyyy = Number(birth.format('YYYY'))
				this.mm = Number(birth.format('MM'))
				this.dd = Number(birth.format('DD'))
				this.userInfo.birthday = birth.format('yyyy-MM-DD')
			}
            if (this.checkUp.heightCm !== 0) {
                this.userInfo.height = this.checkUp.heightCm
            }
            if (this.checkUp.weightKg !== 0) {
                this.userInfo.weight = this.checkUp.weightKg
            }
            if (this.getUser.gender !== null) {
                this.userInfo.gender = this.getUser.gender
                if(this.userInfo.gender === "1") {
                    this.gender_m = true
                } else {
                    this.gender_f = true
                }
            }
		},
        onClickGender(gender) {
            if(gender === 1) {
                if(this.gender_f !== null && this.gender_f){
                    this.gender_f = false
                    this.userInfo.gender = "1"
                } else if (!this.gender_m){
                    this.userInfo.gender = null
                }
            }

            if(gender === 2) {
                if(this.gender_m !== null && this.gender_m){
                    this.gender_m = false
                    this.userInfo.gender = "2"
                } else if (!this.gender_f){
                    this.userInfo.gender = null
                }
            }
        },
        trimDate() {
            if(this.yyyy) {
                const strYYYY = String(this.yyyy)
                if(strYYYY.length > 4) {
                    this.yyyy = Number(strYYYY.substr(0, 4))
                }
            }
            if(this.mm) {
                const strMM = String(this.mm)
                if(strMM.length > 2) {
                    this.mm = Number(strMM.substr(0,2))
                }
            }
            if(this.dd) {
                const strDD = String(this.dd)
                if(strDD.length > 2) {
                    this.dd = Number(strDD.substr(0,2))
                }
            }
        },
        // 팝업 오픈
        async showPopup(type) {
            this.prevScrollY = window.scrollY;
            window.scrollTo(0, 0);
            this[`popupView${type}`] = !this[`popupView${type}`];
        },
        // 팝업 종료
        closePopup(type) {
            window.scrollTo(0, this.prevScrollY);
            this.prevScrollY = 0;
            this[`popupView${type}`] = !this[`popupView${type}`];
        },
	},
	watch: {
        yyyy: async function() {
		    await this.$nextTick()
            this.buttonChange()
		},
		mm: async function() {
            
            this.buttonChange()
            if(this.mm < 13 && this.mm > 0){
                this.errorMsg2 = ''
                await this.$nextTick()
                this.buttonChange()
            } else {
                this.errorMsg2 = "1에서 12 사이의 숫자를 입력하세요"
                this.enableButton = false
            }
		},
		dd: async function() {
            
            this.buttonChange()
            if(this.dd < 32 && this.dd > 0){
                this.errorMsg2 = ''
                await this.$nextTick()
                this.buttonChange()
            } else {
                this.errorMsg2 = "1에서 31 사이의 숫자를 입력하세요"
                this.enableButton = false
            }
		},
		"userInfo.name": async function() {
            if(this.userInfo.name.length === 0) {
                this.errorMsg1 = "이름을 입력하세요"
                this.errorType = 'name'
                this.enableButton = false
            } else {
                this.errorMsg1 = ''
            }
            await this.$nextTick()
			this.buttonChange()
		},
        "userInfo.height": async function() {
            if(this.userInfo.height.length === 0) {
                this.errorMsg3 = "키를 입력하세요"
                this.enableButton = false
            } else {
                this.errorMsg3 = ''
            }
            await this.$nextTick()
			this.buttonChange()
        },
		"userInfo.weight": async function() {
            if(this.userInfo.weight.length === 0) {
                this.errorMsg4 = "몸무게를 입력하세요"
                this.enableButton = false
            } else {
                this.errorMsg4 = ''
            }
            await this.$nextTick()
			this.buttonChange()
		},
        "userInfo.mobile": async function() {
            if(this.userInfo.mobile.length <= 0) {
                this.errorMsg5 = '전화번호를 입력해 주세요.'
                this.enableButton = false
            }
            else {
                this.errorMsg5 = ''
            }
            await this.$nextTick()
            this.buttonChange()
        },
        gender_m: async function() {
            this.changed = 1
            await this.$nextTick()
            if(this.gender_m) this.userInfo.gender = "1"
            else if(!this.gender_f) this.userInfo.gender = null

            if(this.userInfo.gender === null) {
                this.errorMsg0 = "성별을 선택하세요"
                this.enableButton = false
            } else {
                this.errorMsg0 = ''
            }
			this.buttonChange()
        },
        gender_f: async function() {
            this.changed = 1
            await this.$nextTick()
            if(this.gender_f) this.userInfo.gender = "2"
            else if(!this.gender_m) this.userInfo.gender = null

            if(this.userInfo.gender === null) {
                this.errorMsg0 = "성별을 선택하세요"
                this.enableButton = false
            } else {
                this.errorMsg0 = ''
            }
			this.buttonChange()
        },
        'userInfo.isTermsAgree' () {
            this.buttonChange()
        }
	},
	mounted() {
        window.scrollTo(0, 0)
        this.errorMsg = ''
        this.enableButton = false
        this.setStep(1)
		this.restoreData()
	}
};
</script>

<style scoped lang="scss">
    .input-item {
        
        display: inline-block;
    }
    .input_yy {
        width:50px;
        display:inline-block;
        font-size: 0.8em;
    }
    .input_mm {
        width:30px;
        display:inline-block;
        font-size: 0.8em;
    }
    .input_dd {
        width:30px;
        display:inline-block;
        font-size: 0.8em;
    }

    .terms_check {
		display: none;
		position: absolute;
		z-index: -1;
	}

	.terms_check + label {
		background: url(~@/assets/images/renew/ico-check-off.svg) no-repeat;
		display: inline-block;
		padding: 0 0 0 30px;
        cursor: pointer;
        height: 20px;
        font-size: 14px;
	}

	.terms_check:checked + label {
		background: url(~@/assets/images/renew/ico-check-on.svg) no-repeat;
		display: inline-block;
		padding: 0 0 0 30px;
		cursor: pointer;
        height: 20px;
        font-size: 14px;
	}

    .ck_u {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        color: #475b82;
        vertical-align: middle;
        line-height: 24px;
        position: relative;
	}

    .privacy_link {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        position: absolute;
		right: 0;
		color: #767676;
        text-decoration: underline;
	}

    input::-webkit-inner-spin-button,
    input::-webkit-calendar-picker-indicator {
        display: none;
       -webkit-appearance: none;
    }

    .stop1_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

    .step1_title {
        font-family: NanumSquare, sans-serif;
        font-weight: bold;
		font-size: 14px;
        color: #193263;
	}
    
    .default_input {
        height:42px;
        padding: 12px 0 10px 18px;
        width: 100%;
        border-radius: 10px;
        box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.1);
        text-align: left;
        font-size: 1.4em;
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;;
    }
    
    input {
        color: #3f6fff;
        text-align: right;
    }

    .err_ly {
        margin-top: 10px;
        height: 16px;
        margin-bottom: 10px;
    }
    .err_msg {
        font-family:  "NanumSquare", sans-serif;
        font-size: 14px;
        color: #ea5858;
        text-align: center;
        word-break: keep-all;
    }

    ::v-deep label {
        display: block;
        text-align: center;
    }
    
	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }
	::v-deep .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
		background-color: #e6e8ee !important;
	}
	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 639px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }

    .step01_items_title {
        font-size:12px; 
        letter-Spacing:0.6px; 
        color:#193263;
        text-align: left;
    }

    button:disabled,
	button[disabled] {
		color: #ffffff !important;
		// background-color: #a7bdff !important;
		border: solid 0 #a7bdff !important;
	}
</style>
